import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  TextField,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNotification } from "../../hooks/useNotification";
import { saveReferralNotes } from "../../api/referralApi";
export default function AddReferralNotes({refetch, open, onClose,info }) {
  const [notes, setNotes] = useState("");
  const [saving,setSaving] = useState(false)
  const  { showSuccessNotification, showErrorNotification } = useNotification()

    const handleUpdate = () => {
    notes && info._id && saveReferralNotes({setSaving,payload:{_id:info?._id,notes}})
    .then(res=>{
      onClose();
      refetch()
      showSuccessNotification("Saved successfully")
    }).catch(err=>{
      showErrorNotification(err?.message || "Failed to save notes")
    })
  };


  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: "16px" },
      }}
    >
      {/* Title with Close Button */}
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontWeight: 600, fontSize: "20px", color: "#15243E" }}>
          Add Notes
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* Content */}
      <DialogContent>
        {/* Student Details */}
        <Box mb={2}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
            {info?.leadId ? <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#363853", py: 0.5 }}>
              ID: <Typography variant="span" sx={{ fontWeight: "normal" }}>{info?.leadId}</Typography>
            </Typography> :<Box></Box>}
           {info?.status && <Typography variant="span" sx={{ background: '#FFECA0', border: '1px solid #FFE187', textTransform: 'capitalize', color: '#FF6E20', fontSize: '12px', borderRadius: '20px', px: 2, }}>{info?.status}</Typography>}
          </Box>
          {info?.student && 
          <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#363853", py: 1 }}>
            Student: <Typography variant="span" sx={{ fontWeight: "normal" }}>{info?.student}</Typography>
          </Typography> }
          {info?.universityName && <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#363853", py: 1 }}>
            Course: <Typography variant="span" sx={{ fontWeight: "normal" }}>{info?.universityName}</Typography>
          </Typography>}
          
          {info?.preferredDate && <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#363853", py: 1 }}>
            Preferred: <Typography variant="span" sx={{ fontWeight: "normal" }}>{info?.preferredDate}</Typography> at <Typography variant="span" sx={{ fontWeight: "normal" }}>{info?.preferredTime}</Typography>
          </Typography>}
        </Box>

        {/* notes */}
        <Box mb={2}>
          <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#363853", mb: 1 }}>
            Notes*
          </Typography>
          <TextField
            placeholder="Add notes..."
            fullWidth
            multiline
            minRows={3}
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            variant="outlined"
             sx={{
    "& .MuiInputBase-root": {
        fontSize:'14px', 
    },
 "& .MuiInputBase-input::placeholder": {
        fontSize: "14px !important",        
        color: "#6E7485",       
      },
}}
          />
        </Box>
      </DialogContent>

      {/* Footer Actions */}
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button onClick={onClose} variant="outlined" sx={{ width: "100%", height: "50px" }}>
          Cancel
        </Button>
        <Button
          onClick={handleUpdate}
          variant="contained"
          loading={saving}
          disabled={!notes || saving}
          sx={{ background: "#1075FF", width: "100%", height: "50px", "&:hover": { background: "#0d63d6" } }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
